<!--
-@Author: heyu tao
-@since: 2021-11-17 09:45:31
-@LastAuthor: CDS
-@lastTime: 2022-08-26 15:12:50
-@message: file content
-@The path of the file relative to the project: /cds-portal-web/src/components/HeadBar.vue
-->
<template>
  <div class="head-bar-container">
    <div>
      <!-- 左侧logo -->
      <div class="logo" @click="menuTo({ path: '/' })">
        <img :src="logo2" width="50px" height="50px" />
        <img :src="logo" />
      </div>
      <!-- 右侧菜单 -->
      <div class="menus">
        <span
          v-for="(item, index) of menus"
          :key="'menus-' + index"
          @click="menuTo(item)"
        >
          {{ item.label }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// import logo from '@/assets/logo01.png'
import logo2 from "@/assets/logo-blue.png";
import logo from "@/assets/logo.png";
export default {
  data() {
    return {
      logo, // logo图
      logo2,
      menus: [
        // 菜单列表
        { path: "/", label: "首页" },
        { path: "/article", label: "行业资讯" },
        { path: "/article", label: "通知公告" },
        { path: "/article", label: "业务指南" },
        { path: "/article", label: "产品中心" },
        { path: "/article", label: "资料下载" },
        { path: "/article", label: "常见问题" },
      ],
    };
  },
  methods: {
    // 点击菜单，进行跳转
    menuTo(item) {
      this.$router.push({ path: item.path, query: { label: item.label } });
    },
  },
};
</script>

<style lang="less" scoped>
.head-bar-container {
  background-color: #01449b;
  color: #fff;
  width: 1300px;
  margin: auto;
  // min-width: 1903px;
  & > div {
    width: 1270px;
    height: 60px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: 400px;
      height: 35px;
      // background-position: center;
      // background-size: 100%;
      // background-repeat: no-repeat;
      display: flex;
      justify-content: space-between;
      cursor: pointer;
    }
    .menus {
      width: 738px;
      // padding-left:200px;
      display: flex;
      justify-content: space-between;
      span {
        line-height: 60px;
        color: white;
        cursor: pointer;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        &:hover {
          font-weight: bolder;
        }
      }
    }
  }
}
</style>
